import { apiGet, apiPatch } from './client';
import type { InventoryRowType, InventoryRowTypeBatchRequest } from '../types/InventoryRowType';

export function getInventoryRowTypes(): Promise<InventoryRowType[]> {
  return apiGet<InventoryRowType[]>('/api/inventory-row-types');
}

export function saveBatchInventoryRowTypes(added: InventoryRowType[], modified: InventoryRowType[], deletedIds: number[]): Promise<InventoryRowType[]> {
  return apiPatch<InventoryRowTypeBatchRequest, InventoryRowType[]>('/api/inventory-row-types/batch', { added, modified, deleted: deletedIds });
}
